export default __webpack_public_path__ + "0a2a0a5f1809dff60651ee9e66ca042b.woff";